import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { MqDesktop, MqTablet } from 'streamr-ui/css/consts'

const StaticButton = styled.button`
    display: none;
    font-size: 1.125rem;
    line-height: 1.875rem;
    padding: 0;
    position: relative;

    @media ${MqDesktop} {
        display: block;
    }
`

const Linked = styled.div`
    font-size: 1rem;
    line-height: 1rem;

    a {
        color: #b7baff !important;
        display: block;
        font-size: 1.125rem;
        line-height: 2.5rem;
        margin-top: 0.25rem;
    }

    span {
        border-bottom: 1px solid #3c2e6c;
        display: inline-block;
    }

    @media ${MqTablet} {
        a {
            margin-top: 1.25rem;
        }
    }

    @media ${MqDesktop} {
        display: none;
    }
`

const Arrow = styled.svg`
    left: -4.5rem;
    opacity: 0;
    position: absolute;
    top: 0.25rem;
    transition-property: opacity, left;
    transition: 200ms ease-in-out;
    width: 1.5rem;
`

const UnstyledOffice = forwardRef(function UnstyledOffice(
    { address, className, onClick, style },
    ref,
) {
    return (
        <div className={className} style={style} ref={ref}>
            <Linked>
                {address.name}
                <a href={address.mapUrl} target="_blank" rel="noopener noreferrer">
                    <span>{address.street}</span>
                    <br />
                    <span>{`${address.zipcode} ${address.city}, ${address.country}`}</span>
                </a>
            </Linked>
            <StaticButton onClick={() => onClick(address.id)} type="button">
                <Arrow viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill="currentColor"
                        d="M8.107 7.5L9.49 8.852l-2.244 2.192L20.5 11v1.912l-13.254.044 2.244 2.192L8.107 16.5 3.5 12z"
                    />
                </Arrow>
                {address.name}
                <br />
                {address.street}
                <br />
                {`${address.zipcode} ${address.city}, ${address.country}`}
            </StaticButton>
        </div>
    )
})

const Office = styled(UnstyledOffice)`
    a {
        color: inherit !important;
        display: block;
        text-decoration: none !important;
    }

    button {
        appearance: none;
        background-color: transparent;
        border: 0;
        color: inherit;
        outline: 0;
        text-align: left;
    }

    ${({ current }) =>
        !!current &&
        css`
            ${Arrow} {
                left: -5rem;
                opacity: 1;
            }
        `}
`

export default Office
